/**
 * @deprecated
 * This was created when PrimeVue did not have support for composition API, no longer needed
 */
import { defineStore } from "pinia";

export const useToastStore = defineStore("useToastStore", {
    state: () => ({
        severity: "",
        summary: "",
        detail: "",
        life: 5000,
    }),
});
